import React from 'react';
import { Col, DatePicker, Form, Input, InputNumber, Row } from 'antd';
import SPUploadPdfAndImg from '../SPUploadPdfAndImg';
import { API_VEHICLE_UPLOAD_PHOTO } from '../../../../hooks/carRental/_';
import moment from 'moment';
const { RangePicker } = DatePicker;

interface PropsType {
	onChange?: any;
	value?: any;
	enums?: any;
	disabled?: any;
}

const SPCommercialInsurance: React.FC<PropsType> = props => {
	const { disabled } = props;
	const mainFormFields = {
		shangyebaoxiangongsi: {
			name: 'company',
			label: '保险公司',
			required: true,
			message: '请输入保险公司',
			placeholder: '请输入',
		},
		shangyeyouxiaoqi: {
			name: 'effect_time',
			label: '有效期',
			required: true,
			message: '请选择有效期',
			placeholder: '请选择',
		},
		shangyebaoxiandanhao: {
			name: 'no',
			label: '保险单号',
			required: true,
			message: '请输入保险单号',
			placeholder: '请输入',
			pattern: new RegExp('^[a-zA-Z0-9]{0,100}$'),
		},
		disanzhexianedu: {
			name: 'third_insurance_limit',
			label: '第三者险额度',
			required: true,
			message: '请输入第三者险额度',
			placeholder: '请输入',
		},
		shangyetoubaozhengjianhao: {
			name: 'id',
			label: '被保险人证件号',
			required: false,
			message: '请输入被保险人证件号',
			placeholder: '请输入',
			pattern: new RegExp('^[a-zA-Z0-9]{0,100}$'),
		},
		shangyepidanfujian: {
			name: 'attachment',
			label: '批单附件',
			required: false,
			message: '请上传批单附件',
			placeholder: '请上传',
		},
		// shangyezongbaoxianfei: {
		// 	name: 'total_fee',
		// 	label: '总保险费',
		// 	required: false,
		// 	message: '请输入总保险费',
		// 	placeholder: '请输入',
		// },
		// cheliangsunshibaoe: {
		// 	name: 'lose_fee',
		// 	label: '车辆损失保额',
		// 	required: false,
		// 	message: '请输入车辆损失保额',
		// 	placeholder: '请输入',
		// },
		// shangyejiaofeishijian: {
		// 	name: 'pay_time',
		// 	label: '缴费时间',
		// 	required: false,
		// 	message: '请选择缴费时间',
		// 	placeholder: '请选择',
		// },
	};

	const validateThirdLimit = (_: any, value: any) => {
		if (!value) {
			return Promise.reject(new Error('请输入第三者险额度'));
		}
		if (value < 50 || value > 1000000) {
			return Promise.reject(new Error('请输入50-1000000的正整数'));
		}
		return Promise.resolve();
	};

	const validateTime = (_: any, value: any) => {
		if (!value || !value.length || value.length !== 2) {
			return Promise.reject(new Error('请选择有效期'));
		}
		const currentDate = moment();

		if (value[0].isSameOrAfter(currentDate)) {
			return Promise.reject(new Error('开始日期必须小于当前日期'));
		}

		if (value[1].isSameOrBefore(currentDate)) {
			return Promise.reject(new Error('结束日期必须大于当前日期'));
		}
		return Promise.resolve();
	};

	return (
		<>
			<Row gutter={24}>
				<Col span={12}>
					<Form.Item
						name={['commercial_insurance', mainFormFields.shangyebaoxiangongsi.name]}
						label={mainFormFields.shangyebaoxiangongsi.label}
						rules={[
							{
								required: mainFormFields.shangyebaoxiangongsi.required,
								message: mainFormFields.shangyebaoxiangongsi.message,
							},
						]}
					>
						<Input maxLength={100} placeholder={mainFormFields.shangyebaoxiangongsi.placeholder} />
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						required
						name={['commercial_insurance', mainFormFields.shangyeyouxiaoqi.name]}
						label={mainFormFields.shangyeyouxiaoqi.label}
						rules={[
							{
								validator: validateTime,
							},
						]}
					>
						<RangePicker getPopupContainer={(triggerNode: any) => triggerNode.parentNode} />
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={24}>
				<Col span={12}>
					<Form.Item
						name={['commercial_insurance', mainFormFields.shangyebaoxiandanhao.name]}
						label={mainFormFields.shangyebaoxiandanhao.label}
						rules={[
							{
								required: mainFormFields.shangyebaoxiandanhao.required,
								message: mainFormFields.shangyebaoxiandanhao.message,
								pattern: mainFormFields.shangyebaoxiandanhao.pattern,
							},
						]}
					>
						<Input maxLength={100} placeholder={mainFormFields.shangyebaoxiandanhao.placeholder} />
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						required
						name={['commercial_insurance', mainFormFields.disanzhexianedu.name]}
						label={mainFormFields.disanzhexianedu.label}
						rules={[
							{
								validator: validateThirdLimit,
							},
						]}
					>
						<InputNumber
							placeholder={mainFormFields.disanzhexianedu.placeholder}
							controls={false}
							addonAfter="万元"
							precision={0}
							// max={1000000}
							// min={0}
						/>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={24}>
				<Col span={12}>
					<Form.Item
						name={['commercial_insurance', mainFormFields.shangyetoubaozhengjianhao.name]}
						label={mainFormFields.shangyetoubaozhengjianhao.label}
						rules={[
							{
								required: mainFormFields.shangyetoubaozhengjianhao.required,
								message: mainFormFields.shangyetoubaozhengjianhao.message,
								pattern: mainFormFields.shangyetoubaozhengjianhao.pattern,
							},
						]}
					>
						<Input maxLength={100} placeholder={mainFormFields.shangyetoubaozhengjianhao.placeholder} />
					</Form.Item>
				</Col>
				<Col span={12}>
					{/* <Form.Item
						name={['commercial_insurance', mainFormFields.shangyezongbaoxianfei.name]}
						label={mainFormFields.shangyezongbaoxianfei.label}
						rules={[
							{
								required: mainFormFields.shangyezongbaoxianfei.required,
								message: mainFormFields.shangyezongbaoxianfei.message,
							},
						]}
					>
						<InputNumber
							placeholder={mainFormFields.shangyezongbaoxianfei.placeholder}
							controls={false}
							addonAfter="元"
							max={1000000}
							min={0}
						/>
					</Form.Item> */}
					<Form.Item
						name={['commercial_insurance', mainFormFields.shangyepidanfujian.name]}
						label={mainFormFields.shangyepidanfujian.label}
						rules={[
							{
								required: mainFormFields.shangyepidanfujian.required,
								message: mainFormFields.shangyepidanfujian.message,
							},
						]}
						extra="如：1.过户车牌号与保单不一致；2.保单延期等特殊问题，需要上传保险公司批单证明"
					>
						<SPUploadPdfAndImg
							action={API_VEHICLE_UPLOAD_PHOTO}
							fileSize={10}
							fileNum={6}
							disabled={disabled}
						/>
					</Form.Item>
				</Col>
			</Row>
			{/* <Row gutter={24}>
				<Col span={12}>
					<Form.Item
						name={['commercial_insurance', mainFormFields.cheliangsunshibaoe.name]}
						label={mainFormFields.cheliangsunshibaoe.label}
						rules={[
							{
								required: mainFormFields.cheliangsunshibaoe.required,
								message: mainFormFields.cheliangsunshibaoe.message,
							},
						]}
					>
						<InputNumber
							placeholder={mainFormFields.cheliangsunshibaoe.placeholder}
							controls={false}
							addonAfter="元"
							max={1000000}
							min={0}
						/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						name={['commercial_insurance', mainFormFields.shangyejiaofeishijian.name]}
						label={mainFormFields.shangyejiaofeishijian.label}
						rules={[
							{
								required: mainFormFields.shangyejiaofeishijian.required,
								message: mainFormFields.shangyejiaofeishijian.message,
							},
						]}
					>
						<DatePicker
							getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
							placeholder={mainFormFields.shangyejiaofeishijian.placeholder}
						/>
					</Form.Item>
				</Col>
			</Row> */}
		</>
	);
};

export default SPCommercialInsurance;
